<template>
  <div id="app">
    <HomeHeader :isgzh="true"></HomeHeader>
    <div class="body_bg gzhbody_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" class="leftfloat">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style=" margin-bottom: 0;">
                  <div class="title_left">推荐文章</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="dqml">
                       <gzhArticleList  :List="recomList"></gzhArticleList>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import gzhArticleList from '../components/IssueArticleListControl/gzhArticleList'
import HomeHeader from '@/components/MasterTop'
export default {
  data() {
    return {
      keywords: "",
      activeName: "first",
      data: {},
      newList: [],
      List: [],
      Lista: [],
      newListTitle: "",
      CoverGUID: false,
      BackCoverGUID: false,
      TableConGUID: false,
      Rss: false,
      loading:true,
      cotype: "",
      Periods: {},
      FileGUID: "",
      count: 0,
      titles:"",
      isyuchuban: false,
      YearIssue_No:'',
      id:0,
      type:"",
      recomList:[],
      CloumnList:[],
      paramas: {
        PageSize: 10,
        PageIndex: 1,
        IssueId: 0
      },
     
    };
  },
  components: {
    gzhArticleList,
    HomeHeader
  },
  created() {
 
    this.GetRecomList();
    
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.load)
    })
  },
  watch: {
    '$route' (to, from) { 
      if (to.query.IssueId !== from.query.IssueId) {
        this.id = to.query.IssueId
         this.GetIssue();
         this.CloumnList=[]
         this.getArticList(); 
      }
    }
  },
  methods: {
   
GetRecomList(){
			var time =new Date().getTime()
			let data = {
			    "PageSize":100,
                "Type":'Sort',
                "Key":"Recommended",
                "PageIndex":1
			}
			this.$store.dispatch("_getListb",data).then(res=>{
        if(res.data.IsSuccess){
            this.loading=false
          this.recomList=res.data.Data
        }
      }).catch(err=>{
        console.log(err)
      })
		},
   
    load () {
      if(document.documentElement.scrollHeight-document.documentElement.scrollTop<2000){
          if(this.paramas.PageIndex<this.count/10+1){
            this.paramas.PageIndex++;
           
           this.$store.dispatch("_getNewlist", this.paramas).then(res=>{
             this.newList=this.newList.concat(res.data.Data)
            
        })
         }
         
      }
     
      }
  }
};
</script>

<style scoped>


</style>
